import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { StatsService } from '../../providers/stats.service';
import * as Highcharts from 'highcharts';
import BaseStats from '../base-stats';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Accent } from "../../../common/models/stats/accent";
import { MetricsItemComponent } from "../../components/metrics-item/metrics-item";
import { StatsEmptyComponent } from "../../components/stats-empty/stats-empty.component";
import { NgForOf, NgIf, PercentPipe } from "@angular/common";
import { StatsPieChartComponent } from "../../components/stats-pie-chart/stats-pie-chart.component";

@Component({
  selector: 'app-accents-performed-container',
  templateUrl: './accents-performed-container.component.html',
  styleUrls: ['./accents-performed-container.scss', '../../components/metrics-item/metrics-item-list.scss'],
  standalone: true,
  imports: [
    MetricsItemComponent,
    StatsEmptyComponent,
    NgForOf,
    NgIf,
    PercentPipe,
    StatsPieChartComponent
  ],
  providers: [StatsService]
})
export class AccentsPerformedContainerComponent extends BaseStats implements OnInit, OnDestroy {
    public accents: Accent[] = [];
    public accentsLoaded: EventEmitter<any> = new EventEmitter();
    private subscriptions: Subscription[] = [];

    constructor(
        private statsProvider: StatsService,
        private translater: TranslateService,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.accentsLoaded.subscribe((accents: Accent[]) => {
                const accentsData = accents.map((accent) => ({
                    name: accent.name,
                    y: this.percent(accent.occurrence, accent.totalOccurrence),
                    color: accent.color,
                    occurrence: accent.occurrence
                }));
                this.options = {
                    tooltip: {
                      pointFormatter: function(this: any) : string{
                        return '<strong>' + Highcharts.numberFormat(this.y ?? 0, 1) + ' %</strong><br />' +
                          '<strong>' + this.occurrence + ' x</strong>'
                          ;
                      }
                    },
                    series: [{
                        data: accentsData
                    }]
                };
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    protected populateData() {
        this.subscriptions.push(
            this.statsProvider.getAccentsPerformedDataByDate(this.organization, this.athlete, this.dateFrom, this.dateTo).subscribe((accents) => {
                this.accents = accents;
                this.loaded = true;
                this.accentsLoaded.emit(accents);
            })
        );
    }

    protected getTitle() {
        return 'StatsAccents';
    }
}
